import { show, hide, trigger } from './utility';

/// checks-group-depends-on-radio is used when a section need to be hided based on a select element

/// <div data-gs-toggle="checkbox-group-depends-on-radio" data-gs-target="@Html.NameFor(n=>n.AsperfestBoolRadio)" data-gs-show-value="True"></div>

function unCheckAll(elem: HTMLElement) {
    const elems = elem.querySelectorAll("input");
    for (let i = 0; i < elems.length; i++) {
        let childElem = elems[i] as HTMLInputElement;
        if (childElem.type !== "checkbox") {
            // this may be the other text box
            if (childElem.type !== "text") {
                console.log(`non checkbox elem found, please check`);
            }
            continue;
        }
        if (childElem.checked) {
            childElem.checked = false;
            trigger(childElem, 'change')
        }
    }
}

function setup(elem: HTMLElement, radioElems: NodeListOf<HTMLElement>, shouldCheckElem: HTMLInputElement) {
    const elems = elem.querySelectorAll("input");
    for (let i = 0; i < elems.length; i++) {
        let childElem = elems[i] as HTMLInputElement;
        if (childElem.type !== "checkbox") {
            // this may be the other text box
            if (childElem.type !== "text") {
                console.log(`non checkbox elem found, please check`);
            }
            continue;
        }
        childElem.addEventListener('change', function (e) {
            if (childElem.checked) {
                for (let i = 0; i < radioElems.length; i++) {
                    let radioElem = radioElems[i] as HTMLInputElement;
                    let desired = false;
                    if (radioElem === shouldCheckElem) {
                        desired = true
                    }
                    if (desired !== radioElem.checked) {
                        radioElem.checked = desired;
                        trigger(radioElem, 'change')
                    }
                }
            }
        })
    }
}

export function checkboxGroupDependsOnRadio(targetElem: HTMLElement) {
    let radioName = targetElem.dataset['gsTarget'];
    let radioElems = document.getElementsByName(radioName);
    if (radioElems.length == 0) {
        throw new Error(`Can not find target element: ${radioName}`);
    }
    let showValue = targetElem.dataset['gsShowValue'];
    if (showValue === undefined) {
        throw new Error('Please provide the data-gs-show-value attribute');
    }
    let shouldCheckElem;
    for (let i = 0; i < radioElems.length; ++i) {
        var radioElem = radioElems[i] as HTMLInputElement;
        if (radioElem.nodeName !== "INPUT" || radioElem.type != "radio") {
            throw new Error(`the target element select by ${radioName} is not a radio element`);
        }
        if (radioElem.value === showValue) {
            shouldCheckElem = radioElem
        }
        radioElem.addEventListener('change', function (event) {
            var currValElem = event.target as HTMLInputElement;
            if (!currValElem.checked) {
                return;
            }
            if (currValElem.value !== showValue) {
                unCheckAll(targetElem);
            }
        });
    }
    if (!shouldCheckElem) {
        throw new Error(`could not find an element with name ${radioName},value ${showValue}`)
    }
    setup(targetElem, radioElems, shouldCheckElem);
}